package one.healthium.login.ui.login

import one.healthium.domain.user.UserModel

data class LoginUiState(
    val loading: Boolean = false,
    val signInOptions: SignInUiOptions = SignInUiOptions(),
    val user: UserModel? = null,
)
